module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('side-bar', {
    attrs: {
      "type": "sidebar",
      "sidebar-links": _vm.$sidebar.sidebarLinks
    }
  }), _vm._v(" "), _c('notifications'), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('top-navbar'), _vm._v(" "), _c('dashboard-content', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSidebar($event)
      }
    }
  }), _vm._v(" "), _c('content-footer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a169b042!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/DashboardLayout.vue
// module id = 376
// module chunks = 1